import { render, staticRenderFns } from "./QuickLinks.vue?vue&type=template&id=70957d88&scoped=true"
import script from "./QuickLinks.vue?vue&type=script&lang=js"
export * from "./QuickLinks.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70957d88",
  null
  
)

export default component.exports